import React from 'react';

import { usePublicationContext } from 'components/Publication/PublicationContext';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { useAppSelector } from 'store/hook';

import CMASummaryTable from './CMASummaryTable';
import { CMASummaryFilters } from './types';

const CMASummaryTableContainer = () => {
  const { competitors, competitorId, viewFilters } = useCommunityViewContext();
  const { publication } = usePublicationContext();
  const { competitors: globalCompetitors } = useAppSelector((state) => state.global);
  const selectedCompetitorId = Number(competitorId);
  const publicCompetitorFallback = publication?.hash
    ? globalCompetitors.find((competitor) => competitor.id === selectedCompetitorId)
    : undefined;
  const competitorList = competitors?.length ? competitors : globalCompetitors;

  const availableCompetitors = competitorId
    ? (competitorList ?? []).filter((competitor) => competitor.id === selectedCompetitorId)
    : (competitors ?? []);

  if (competitorId && !availableCompetitors.length && publicCompetitorFallback) {
    availableCompetitors.push(publicCompetitorFallback);
  }

  const filters = viewFilters as CMASummaryFilters;
  const filteredCompetitors = competitorId
    ? availableCompetitors
    : filters?.competitors?.length
    ? availableCompetitors.filter((competitor) => filters?.competitors.includes(competitor.id))
    : availableCompetitors;

  return <CMASummaryTable filteredCompetitors={filteredCompetitors} />;
};

export default CMASummaryTableContainer;
